/* ============================================================================
   MALSERA — ms-panel.js
   Paneles: la guía de tallas, las tres notas de debajo del botón de compra y
   la fila de envíos del carrito. Los tres abren la MISMA caja.

   Va en el layout, no en la ficha: el carrito está en todas las páginas, así
   que su panel tiene que funcionar en todas. Antes esta clase vivía dentro de
   ms-product.js y eso dejaba el botón del carrito muerto fuera de la ficha.
   ============================================================================ */

/**
 * Paneles. Los usan la guía de tallas y las tres notas de debajo del botón de
 * compra. El panel es un <dialog> nativo: lo abre y lo cierra el propio
 * navegador con command="show-modal" / command="close", sin una línea de
 * JavaScript. El foco atrapado, la tecla Escape, la capa superior y el resto
 * de la página inerte los da la plataforma; no se reimplementan aquí.
 *
 * Esta clase cubre solo los dos huecos que deja esa API:
 *   1. Navegadores anteriores a command/commandfor: se abre y se cierra a mano.
 *   2. Navegadores sin closedby="any": cierre al pulsar el velo.
 * Si mañana ninguno de los dos hace falta, este archivo se queda más corto.
 */
class MsPanel extends HTMLElement {
  connectedCallback() {
    this.dialogo = this.querySelector('dialog');
    if (!this.dialogo) return;

    if (!('command' in HTMLButtonElement.prototype)) {
      document.querySelectorAll(`[commandfor="${this.dialogo.id}"]`).forEach((disparador) => {
        disparador.addEventListener('click', () => this.dialogo.showModal());
      });
    }

    this.querySelectorAll('[data-ms-guia-close]').forEach((boton) => {
      boton.addEventListener('click', () => this.dialogo.close());
    });

    // Un clic sobre el velo llega con target en el propio <dialog>: el panel
    // no tiene relleno, así que dentro del contenido nunca ocurre.
    if (!('closedBy' in this.dialogo)) {
      this.dialogo.addEventListener('click', (evento) => {
        if (evento.target === this.dialogo) this.dialogo.close();
      });
    }
  }
}
// Dos etiquetas, el mismo comportamiento. Un elemento personalizado no puede
// registrarse dos veces con el mismo constructor, así que la segunda va como
// subclase vacía. Es la forma corta de decir "esto es otro panel".
customElements.define('ms-guia-tallas', MsPanel);
customElements.define('ms-panel-info', class extends MsPanel {});
